import groupBy from 'lodash/groupBy';
import map from 'lodash/map';
import filter from 'lodash/filter';
import { extractDate, validDate } from 'components/Section/History/dateranges';

export const isEmptyObj = (obj) => obj && Object.keys(obj).length === 0 && obj.constructor === Object;

export const getCurrentAddressFromForm = (form) => {
  let address = {};
  const items = form?.HISTORY_RESIDENCE?.data?.List?.items || [];
  items.forEach((item) => {
    if (item?.Item?.Dates?.present && item?.Item?.Address) {
      address = item.Item.Address;
    }
  });
  return address;
};

export const sortItemsByDate = (items) => items.sort((a, b) => {
  if (
    a.Item
      && a.Item.Dates
      && validDate(a.Item.Dates.to)
      && b.Item
      && b.Item.Dates
      && validDate(b.Item.Dates.to)
  ) {
    const aDateObj = a.Item.Dates.to;
    const bDateObj = b.Item.Dates.to;
    const aDate = extractDate(aDateObj);
    const bDate = extractDate(bDateObj);

    return bDate.getTime() - aDate.getTime();
  }

  return 0;
});

/**
 * Checks for any true value 1, true, t, yes, on as a string, number, or boolean
 * @param {string|number|boolean|undefined|null} value -
 * @returns bool
 */
export const isTrue = (value) => {
  if (!value) {
    return false;
  }
  const testText = String(value).toLowerCase();
  switch (true) {
    case value === true:
    case value === 1:
    case testText === 'true':
    case testText === 't':
    case testText === 'yes':
    case testText === 'on':
    case testText === '1':
      return true;
    default:
      return false;
  }
};

export const getUniqueDuplicateValuesFromArray = (array) => {
  const groupedValues = groupBy(array); // ["United States", "United States", "Iraq"] => {"United States":["United States","United States"],"Iraq":["Iraq"]}
  const newArray = map(groupedValues, (value, key) => (value.length > 1 ? key : null)); // create new array with keys if occurred more than once, or null if only occurring once
  return filter(newArray, (v) => v); // filter truthy values
};
